import { state } from '@angular/animations';
import { createReducer, on } from '@ngrx/store';

import { clearFullList, editFULLOECIF, editFULLOEPF, loadFullList, loadFullListSucess, rankChangeFull, selectProposalFull, unSelectFull, updateFullListFromRecuse } from './fullList.actions';


export interface FullState {
    itemList: any[],
    status: string | 'pending' | 'loading' | 'success' | 'error',
    error: string | null,
    selectedFullUUID: string | null | any
}

// export const initialQuadState: QuadState = {
//   itemList: [],
//   status: 'pending',
//   error: null,
// };

export interface startState {
    FullState: FullState
}

export const initialState: FullState = {
    itemList: [],
    status: 'pending',
    error: null,
    selectedFullUUID: null
};

export const FullListReducer = createReducer(
    initialState,
    on(loadFullListSucess, (state, { fullList }) => {
        let newState = ({
            ...state,
            status: 'success',
            itemList: fullList
        })
        return newState
    }),
    on(loadFullList, (state) => {
        return ({
            ...state,
            status: 'loading'
        })
    }),
    on(unSelectFull, (state)=> {
    return ({
        ...state,
        status: 'success',
        ...state.itemList,
        selectedFullUUID: null
    })
    }),
    on(selectProposalFull, (state, { propUUID }) => {
        let filterObj = state.itemList.findIndex((item) => item.uuid == propUUID)
        let newState = ({
            ...state,
            selectedFullUUID: propUUID,
            itemList: [...state.itemList].map(proposal => ({ ...proposal })).map((newProposal, localIndex) => {
                let localEdit = newProposal
                if (localEdit.uuid === propUUID.uuid) {
                    localEdit['selected'] = true
                }
                else {
                    localEdit['selected'] = false
                }
                return localEdit
            })
        })
        return newState
    }),
    on(updateFullListFromRecuse, (state, { fullList }) =>{
        let newState =  ({
            ...state,
            status: 'success',
            itemList: fullList
        })
        return newState
    }),
    on(editFULLOECIF, (state, { listItem })=> {
        let newState = ({
          ...state,
          itemList: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{
            let localEdit = newProposal
            if(listItem.id === localEdit.uuid)
            {
              //Update the formStatus
              let newFull = ({
                full_questions: {
                  ...listItem,
                  formStatus: listItem.formStatus
                }
              })
              localEdit.full_questions = newFull.full_questions
            }
            return localEdit
          }),
          selectedQuad: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{
            let localEdit = newProposal
            if(listItem.id === localEdit.uuid)
            {
              //Update the formStatus
              let newFull = ({
                full_questions: {
                  ...listItem,
                  formStatus: listItem.formStatus
                }
              })
              localEdit.full_questions = newFull.full_questions
            }
            return localEdit
          })
        })
        return newState
      }),
    on(editFULLOEPF, (state, { listItem })=> {
      let newState = ({
        ...state,
        itemList: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{
          let localEdit = newProposal
          if(listItem.id === localEdit.uuid)
          {
            //Update the formStatus
            let newFull = ({
              full_questions: {
                ...listItem,
                formStatus: listItem.formStatus
              }
            })
            localEdit.full_questions = newFull.full_questions
          }
          return localEdit
        }),
        selectedQuad: [...state.itemList].map(proposal=>({...proposal})).map((newProposal, localIndex)=>{
          let localEdit = newProposal
          if(listItem.id === localEdit.uuid)
          {
            //Update the formStatus
            let newFull = ({
              full_questions: {
                ...listItem,
                formStatus: listItem.formStatus
              }
            })
            localEdit.full_questions = newFull.full_questions
          }
          return localEdit
        })
      })
      return newState
    }),
    on(rankChangeFull, (state, {rankInfo})=> {
      let existingList = [...state.itemList]

      // function arraymove(arr, fromIndex, toIndex) 
      let fromIndex = rankInfo.previousIndex
      let toIndex = rankInfo.currentIndex
      let element = existingList[fromIndex];
      existingList.splice(fromIndex, 1);
      existingList.splice(toIndex, 0, element);
      let newList: any[] = []
      existingList.forEach(({...doc}, index)=>{
        doc.rank = index+1
        newList.push(doc)
      })

      return ({
        ...state,
        itemList: newList,
        status: 'success'
      })
    }),
    on(clearFullList, (state)=> {
      return ({
        ...state,
        status: 'success',
        itemList: []
      })
    }),
);